// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__wFMqw","content":"styles_content__Whr1Q","checkbox":"styles_checkbox__2Qhzp","checkboxLabel":"styles_checkboxLabel__2L7HC"};